module.exports = __webpack_public_path__ + "static/media/4ODA14.8ef98b8e.jpg";